/**
 * Header counter, toasts, button states, heart animation.
 */
(function () {
  'use strict';

  const TOAST_DURATION = 3200;

  function updateWishlistButtonState(btn, inList) {
    const addLabel = btn.getAttribute('data-aria-add') || btn.getAttribute('aria-label') || '';
    const removeLabel = btn.getAttribute('data-aria-remove') || addLabel;
    btn.classList.toggle('active', inList);
    btn.setAttribute('aria-pressed', inList ? 'true' : 'false');
    btn.setAttribute('aria-label', inList ? removeLabel : addLabel);
  }

  function syncAllButtons() {
    const S = window.WishlistStorage;
    if (!S) return;
    const list = new Set(S.getWishlist());
    document.querySelectorAll('.wishlist-btn[data-product-id]').forEach((btn) => {
      const id = S.normalizeProductId(btn.getAttribute('data-product-id'));
      updateWishlistButtonState(btn, id ? list.has(id) : false);
    });
  }

  function updateCounter() {
    const el = document.getElementById('wishlist-count');
    if (!el || !window.WishlistStorage) return;
    const n = window.WishlistStorage.getWishlist().length;
    el.textContent = n > 99 ? '99+' : String(n);
    const wrap = document.getElementById('wishlist-header-count-wrap');
    if (wrap) {
      wrap.classList.toggle('wishlist-count-bubble--empty', n === 0);
      wrap.setAttribute('aria-hidden', n === 0 ? 'true' : 'false');
    }
    const link = document.getElementById('wishlist-header-link');
    if (link) {
      const tpl = window.wishlistStrings && window.wishlistStrings.nav_aria;
      if (tpl && typeof tpl === 'string') {
        link.setAttribute('aria-label', tpl.replace(/\{count\}/g, String(n)));
      }
    }
  }

  let toastRoot = null;

  function ensureToastRoot() {
    if (toastRoot) return toastRoot;
    toastRoot = document.createElement('div');
    toastRoot.className = 'wishlist-toast-root';
    toastRoot.setAttribute('aria-live', 'polite');
    document.body.appendChild(toastRoot);
    return toastRoot;
  }

  function showToast(message) {
    if (!message) return;
    const root = ensureToastRoot();
    const t = document.createElement('div');
    t.className = 'wishlist-toast';
    t.textContent = message;
    root.appendChild(t);
    requestAnimationFrame(() => t.classList.add('wishlist-toast--visible'));
    setTimeout(() => {
      t.classList.remove('wishlist-toast--visible');
      t.addEventListener('transitionend', () => t.remove(), { once: true });
      setTimeout(() => {
        if (t.parentNode) t.remove();
      }, 400);
    }, TOAST_DURATION);
  }

  function toastFromWishlistAction(added) {
    const S = window.wishlistStrings;
    if (!S) return;
    showToast(added ? S.toast_added || '' : S.toast_removed || '');
  }

  function setLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('wishlist-btn--loading', !!on);
    btn.disabled = !!on;
  }

  function animateHeart(btn) {
    if (!btn || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    btn.classList.remove('wishlist-btn--pop');
    void btn.offsetWidth;
    btn.classList.add('wishlist-btn--pop');
    btn.addEventListener('animationend', () => btn.classList.remove('wishlist-btn--pop'), { once: true });
  }

  document.addEventListener('wishlist:updated', () => {
    syncAllButtons();
    updateCounter();
  });

  window.WishlistUI = {
    syncAllButtons,
    updateCounter,
    updateWishlistButtonState,
    showToast,
    toastFromWishlistAction,
    setLoading,
    animateHeart,
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      syncAllButtons();
      updateCounter();
    });
  } else {
    syncAllButtons();
    updateCounter();
  }
})();
